import {BankAccountTypeReload} from '../components/Bank/BankAccountTypeReload';
import BankDataFields from '../components/Bank/BankDataFields';
import DefaultInput from '../components/GenericEntryFields/DefaultInput';
import DisabledInput from '../components/GenericEntryFields/DisabledInput';
import {PsrReplay} from '../components/PsrReplay';
import RepresentativeDataFields from '../components/RepresentativeDataFields';
import {TermsConditionsReplay} from '../components/TermsConditionsReplay';
import {IMaskInputWrapper} from '../shared/components/IMaskInputWrapper';

import {IMASK_DEFINITIONS, IMASK_PATTERNS} from './imaskPatterns';

export const INPUT_USER = {
  disabled: () => (
    <div
      data-testid="disabled"
      data-aut-test="disabled-input"
      className="user-input"
    >
      <DisabledInput />
    </div>
  ),
  cnpj: ({props}) => (
    <div data-testid="cnpj" data-aut-test="input-cnpj" className="user-input">
      <IMaskInputWrapper
        className="input-message"
        type="text"
        name="message"
        id="message"
        data-testid="message"
        onChange={props.onChange}
        mask={IMASK_PATTERNS.CNPJ}
        definitions={IMASK_DEFINITIONS.CNPJ}
        autoComplete="off"
        placeholder="Digite seu CNPJ"
      />
    </div>
  ),
  'informations-cnpj-cnae': ({props}) => (
    <div
      data-testid="informations-cnpj-cnae"
      data-aut-test="informations-cnpj-cnae"
      className="user-input"
    >
      <IMaskInputWrapper
        className="input-message"
        type="text"
        name="message"
        id="message"
        onChange={props.onChange}
        mask={IMASK_PATTERNS.CNAE}
        autoComplete="off"
        placeholder="Digite seu CNAE"
      />
    </div>
  ),
  'partner-birth-date-input': ({props}) => (
    <div
      data-testid="partner-birth-date-input"
      data-aut-test="partner-birth-date-input"
      className="user-input"
    >
      <IMaskInputWrapper
        className="input-message"
        type="text"
        name="message"
        id="message"
        onChange={props.onChange}
        mask={IMASK_PATTERNS.BIRTHDATE}
        autoComplete="off"
        placeholder="Digite sua data de nascimento"
      />
    </div>
  ),
  'partner-phone-input': ({props}) => (
    <div
      data-testid="partner-phone-input"
      data-aut-test="partner-phone-input"
      className="user-input"
    >
      <IMaskInputWrapper
        className="input-message"
        type="text"
        name="message"
        id="message"
        onChange={props.onChange}
        mask={IMASK_PATTERNS.PHONE}
        autoComplete="off"
        placeholder="Digite seu telefone"
      />
    </div>
  ),
  'partner-email-input': ({props}) => (
    <div
      data-testid="partner-email-input"
      data-aut-test="partner-email-input"
      className="user-input"
    >
      <input
        className="input-message"
        type="text"
        name="message"
        id="message"
        onChange={props.onChange}
        value={props.value}
        autoComplete="off"
        placeholder="Digite seu e-mail"
      />
    </div>
  ),
  'partner-cpf-input': ({props}) => (
    <div
      data-testid="partner-cpf-input"
      data-aut-test="partner-cpf-input"
      className="user-input"
    >
      <IMaskInputWrapper
        className="input-message"
        type="text"
        name="message"
        id="message"
        onChange={props.onChange}
        mask={IMASK_PATTERNS.CPF}
        autoComplete="off"
        placeholder="Digite seu CPF"
      />
    </div>
  ),
  'define-number-partners': ({props}) => (
    <div
      data-testid="define-number-partners"
      data-aut-test="define-number-partners"
      className="user-input"
    >
      <input
        className="input-message"
        type="number"
        name="message"
        id="message"
        onChange={props.onChange}
        value={props.value}
        autoComplete="off"
        placeholder="Digite a quantidade de sócios"
      />
    </div>
  ),
  'address-zipcode-input': ({props}) => (
    <div
      data-testid="address-zipcode-input"
      data-aut-test="address-zipcode-input"
      className="user-input"
    >
      <IMaskInputWrapper
        className="input-message"
        type="text"
        name="message"
        id="message"
        onChange={props.onChange}
        mask={IMASK_PATTERNS.CEP}
        autoComplete="off"
        placeholder="Digite o CEP"
      />
    </div>
  ),
  'address-state-from-api-input': ({props}) => (
    <div
      data-testid="address-state-from-api-input"
      data-aut-test="address-state-from-api-input"
      className="user-input"
    >
      <input
        className="input-message"
        type="text"
        name="message"
        id="message"
        onChange={props.onChange}
        value={props.value.toUpper}
        placeholder="Digite a sigla do estado"
        maxLength="2"
      />
    </div>
  ),
  'address-zipcode-correspondencia-from-api-input': ({props}) => (
    <div
      data-testid="address-zipcode-correspondencia-from-api-input"
      data-aut-test="address-zipcode-correspondencia-from-api-input"
      className="user-input"
    >
      <IMaskInputWrapper
        className="input-message"
        type="text"
        name="message"
        id="message"
        mask={IMASK_PATTERNS.CEP}
        onChange={props.onChange}
        placeholder="Digite o CEP"
      />
    </div>
  ),
  'address-zipcode-loja-from-api-input': ({props}) => (
    <div
      data-testid="address-zipcode-loja-from-api-input"
      data-aut-test="address-zipcode-loja-from-api-input"
      className="user-input"
    >
      <IMaskInputWrapper
        className="input-message"
        type="text"
        name="message"
        id="message"
        mask={IMASK_PATTERNS.CEP}
        onChange={props.onChange}
        placeholder="Digite o CEP da sua Loja"
      />
    </div>
  ),
  'address-zipcode-without-info-bureau-input': ({props}) => (
    <div
      data-testid="address-zipcode-without-info-bureau-input"
      data-aut-test="address-zipcode-without-info-bureau-input"
      className="user-input"
    >
      <IMaskInputWrapper
        className="input-message"
        type="text"
        name="message"
        id="message"
        mask={IMASK_PATTERNS.CEP}
        onChange={props.onChange}
        placeholder="Digite o CEP que o CNPJ está cadastrado"
      />
    </div>
  ),
  'address-number-from-api-input': ({props}) => (
    <div
      data-testid="address-number-from-api-input"
      data-aut-test="address-number-from-api-input"
      className="user-input"
    >
      <input
        className="input-message"
        type="number"
        name="message"
        id="message"
        onChange={props.onChange}
        value={props.value}
        autoComplete="off"
        placeholder="Digite o número do local"
      />
    </div>
  ),
  'address-complement-from-api-input': ({props}) => (
    <div className="user-input">
      <input
        className="input-message"
        type="text"
        name="message"
        id="message"
        onChange={props.onChange}
        value={props.value.slice(0, 100)}
        autoComplete="off"
        placeholder="Digite o complemento do local"
      />
    </div>
  ),
  'flow-bank': ({props}) => <BankDataFields {...props} />,
  'account-bank-type-error': () => <BankAccountTypeReload />,
  'set-ec-representative-data': ({props}) => (
    <RepresentativeDataFields {...props} />
  ),
  'erro-get-conditions': () => <TermsConditionsReplay />,
  'psr-get-error': () => <PsrReplay />,
  'zipcode-input': ({props}) => (
    <div data-testid="zipcode-input" className="user-input">
      <IMaskInputWrapper
        className="input-message"
        type="text"
        name="message"
        id="message"
        data-testid="message"
        onChange={props.onChange}
        mask={IMASK_PATTERNS.CEP}
        autoComplete="off"
        placeholder="Digite o CEP que o CNPJ está cadastrado"
      />
    </div>
  ),

  default: ({props}) => (
    <div
      data-testid="default"
      data-aut-test="default"
      className="user-input-default"
    >
      <DefaultInput {...props} />
    </div>
  )
};
